import type { TransactionCurrency } from '@contracts/payment/Currency';
import { PaymentClient } from '@src/orders/services/PaymentClient';
import { useMutation } from '@tanstack/react-query';

type Props = {
  onSuccess: () => void;
  onError: () => void;
};

type DeleteCreditCardArgs = {
  clientId: string;
  creditCardId: string;
  currency: TransactionCurrency;
};

export const useDeleteCreditCard = ({ onSuccess, onError }: Props) => {
  const { mutate } = useMutation({
    mutationFn: ({ clientId, creditCardId, currency }: DeleteCreditCardArgs) =>
      PaymentClient.deleteCreditCard(clientId, creditCardId, currency),
    onSuccess,
    onError,
  });

  return {
    deleteCreditCard: mutate,
  };
};
